"use client";

import HomePage from "@/components/HomePage";
import MobileHomePage from "@/components/MobileHomePage";
import { useMediaSize } from "@/hooks/useMediaSize";

export default function HomePageSelector() {
  const { isMobile } = useMediaSize();
  
  return isMobile ? <MobileHomePage /> : <HomePage />;
}